import { TableRow, styled } from '@/core/ui';
import { getSelectedRowOutlineStyles } from '../ReceiptItemTableRow';
export const SelectableTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => {
    const outlineStyles = selected ? getSelectedRowOutlineStyles(theme) : undefined;
    return {
        ...outlineStyles,
    };
});
